import { QuestionStep } from '../QuestionStep';
import { MultiChip } from './_shared';
import {
  LANDING_CONTENT_OPTIONS,
  STEPS,
  type QuestionnaireAnswers,
} from '../questions';

interface LandingContentStepProps {
  answers: QuestionnaireAnswers;
  onChange: (next: Partial<QuestionnaireAnswers>) => void;
}

export function LandingContentStep({ answers, onChange }: LandingContentStepProps) {
  const step = STEPS.find((s) => s.id === 'landing')!;
  return (
    <QuestionStep step={step}>
      <MultiChip
        options={LANDING_CONTENT_OPTIONS}
        values={answers.landing_content ?? []}
        onChange={(v) => onChange({ landing_content: v })}
      />
      <p className="mt-6 max-w-xl font-mono text-[11px] text-graphite leading-relaxed">
        <span className="text-ochre">¶</span>&nbsp;&nbsp;Pick everything that should appear above and below the hero on your landing page. AURA orders them sensibly.
      </p>
    </QuestionStep>
  );
}
